import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SubscriptionPage.css';

const SubscriptionPage = ({ onSubscribe }) => {
    const navigate = useNavigate();
    const [selectedPlan, setSelectedPlan] = useState('free');
    const [paymentStep, setPaymentStep] = useState(1); // 1: Plan Selection, 2: Payment

    const plans = [
        { id: 'free', name: 'Essai Gratuit', price: '0', features: ['5 Images', 'Résolution Standard', 'Usage Personnel'] },
        { id: 'standard', name: 'Standard', price: '9.90', features: ['50 Renders', 'Standard Res', 'Usage Commercial'] },
        { id: 'pro', name: 'Pro', price: '19.90', features: ['200 Renders', '4K Res', 'Capture 3D', 'Support Prio'] },
        { id: 'ent', name: 'Entreprise', price: 'Devis', features: ['Illimité', 'API', 'Chef de Projet', 'Support Dédié'] },
    ];

    const handleSubscribe = (e) => {
        e.preventDefault();
        // Simulate payment processing
        setTimeout(() => {
            onSubscribe(selectedPlan);
        }, 1500);
    };

    return (
        <div className="sub-container">
            <div className="simple-nav">
                <button className="brand-home-link-sub" onClick={() => navigate('/')}>ARCHIVIZAI</button>
            </div>
            <div className="sub-header">
                <h2>Abonnement</h2>
            </div>

            <div className="sub-content">
                {paymentStep === 1 ? (
                    <div className="plan-selection-step">
                        <h3>Choisissez votre offre</h3>
                        <div className="simple-plans-grid">
                            {plans.map(plan => (
                                <div
                                    key={plan.id}
                                    className={`simple-plan-card ${selectedPlan === plan.id ? 'selected' : ''} ${plan.id !== 'free' ? 'locked' : ''}`}
                                    onClick={() => {
                                        if (plan.id === 'free') {
                                            setSelectedPlan(plan.id)
                                        }
                                    }}
                                    style={plan.id !== 'free' ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                >
                                    <div className="plan-name">{plan.name}</div>
                                    <div className="plan-price">{plan.price}€</div>
                                    <ul className="plan-features">
                                        {plan.features.map((f, i) => <li key={i}>{f}</li>)}
                                    </ul>
                                    <div className="radio-indicator"></div>
                                </div>
                            ))}
                        </div>
                        <button className="sub-cta-btn" onClick={() => {
                            if (selectedPlan === 'free') {
                                navigate('/inscription');
                            } else {
                                setPaymentStep(2);
                            }
                        }}>
                            {selectedPlan === 'free' ? 'Commencer l\'essai' : 'Continuer'}
                        </button>
                    </div>
                ) : (
                    <div className="payment-step">
                        <h3>Paiement Sécurisé</h3>
                        <p className="summary-text">Vous avez choisi le plan <strong>{plans.find(p => p.id === selectedPlan)?.name}</strong></p>

                        <form className="payment-form" onSubmit={handleSubscribe}>
                            <div className="input-row">
                                <input type="text" placeholder="Nom sur la carte" className="sub-input" required />
                            </div>
                            <div className="input-row">
                                <input type="text" placeholder="Numéro de carte" className="sub-input" required />
                            </div>
                            <div className="input-row split">
                                <input type="text" placeholder="MM/AA" className="sub-input" required />
                                <input type="text" placeholder="CVC" className="sub-input" required />
                            </div>

                            <button type="submit" className="sub-cta-btn">Payer et s'abonner</button>
                            <button type="button" className="text-btn" onClick={() => setPaymentStep(1)}>Modifier l'offre</button>
                        </form>
                    </div>
                )}
            </div>
        </div >
    );
};

export default SubscriptionPage;
